import { render, staticRenderFns } from "./florist-request-view.vue?vue&type=template&id=22052c48"
import script from "./florist-request-view.vue?vue&type=script&lang=js"
export * from "./florist-request-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports